import styled from 'styled-components';
import { transition } from '../../styles/mixins';

const Root = styled.div`
  width: ${props => props.$width && props.$width}px;
  position: relative;
  z-index: 0;

  img {
    vertical-align: middle;
    width: 100%;
  }

  &::after {
    ${transition('opacity, scale')}
    aspect-ratio: 1;
    background-color: var(--color-theme-accent-500);
    border-radius: 100%;
    border: var(--border-width) var(--border-style) var(--color-theme-accent-400);
    content: '';
    inset: calc(var(--space-3) * -1);
    opacity: ${props => props.$selected ? '1' : '0'};
    position: absolute;
    scale: ${props => props.$selected ? '1' : '0'};
    z-index: -1;
  }
`;

function WaypointType({ type, symbol, selected }) {
  const sizes = () => {
    let size;

    if (type == 'PLANET') {
      size = 64;
    }

    if (type == 'ASTEROID') {
      size = 64;
    }

    if (type == 'GAS_GIANT') {
      size = 128;
    }

    if (type == 'MOON') {
      size = 32;
    }

    if (type == 'ORBITAL_STATION') {
      size = 32;
    }

    if (type == 'JUMP_GATE') {
      size = 72;
    }

    if (type == 'FUEL_STATION') {
      return 72;
    }

    if (type == 'ASTEROID_BASE') {
      size = 72;
    }

    if (type == 'ORBITAL_STATION') {
      size = 48;
    }

    return size;
  }


  const getPlanetSuffix = (symbol) => {
    let total = 0;

    if (symbol == undefined) return;

    for (let i = 0; i < symbol.length; i++) {
      total += symbol.charCodeAt(i);
    }

    const totalToString = total + '';

    return totalToString[totalToString.length - 1];
  }

  return (
    <Root $width={sizes()} $selected={selected}>
      {type == 'PLANET' || type == 'GAS_GIANT'
       ? <img src={`../images/waypoint/types/${type}_${getPlanetSuffix(symbol)}.png`} alt={type} />
       : <img src={`../images/waypoint/types/${type}.png`} alt={type} />
      }
    </Root>
  )
}

export default WaypointType;
